import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { COMMON_ENTITY_CONFIG, CommonEntityService, EntityServiceConfig, HttpGetParams, StorageService, UiService } from 'ui-ionic-comp';
import { Organization, Organizations } from './organization.entity';
import { OrganizationSystemAttribute } from '../organization-system-attributes/organization-system-attribute.entity';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends CommonEntityService<any> {
  // Services
  private storageService = inject(StorageService);

  // Signals
  teamTypes = signal<OrganizationSystemAttribute[]>([]);
  organization = signal<Organization | undefined>(undefined)

  get organizations(): WritableSignal<Organizations | undefined> {
    return this.entities;
  }

  setOrganization(organization: Organization) {
    this.storageService.setStorage('organization', JSON.stringify(organization));

    this.organization.set(organization);
  }

  constructor(
    @Inject(COMMON_ENTITY_CONFIG) private _config: EntityServiceConfig,
    private httpClient: HttpClient,
    private uiService: UiService) {

    super(_config, httpClient, uiService);

    this.apiDir = 'organizations';
  }

  async getOrganization(): Promise<Organization | null> {
    const _organization = await this.storageService.getStorage('organization');

    return _organization?.value ? JSON.parse(_organization.value) : null;
  }

  /**
   * Retrieves a list of organizations as an observable.
   *
   * @returns {Observable<Organizations>} An observable containing the list of organizations.
   */
  getOrganizations$(): Observable<Organizations> {
    const params: HttpGetParams = {
      endpoint: ``
    };

    return this.getEntities$(params) as Observable<Organizations>;
  }

  getTeamTypes$(orgaId: string): Observable<OrganizationSystemAttribute[]> {
    const params: HttpGetParams = {
      endpoint: `${orgaId}/team-types`
    };

    const teamTypes = this.getEntities$(params);

    return teamTypes.pipe(
      map(x => x.contents),
      tap(teamTypes => this.teamTypes.set(teamTypes))
    );
  }

  async loadOrganizationFromStorage(): Promise<Organization | null> {
    const organization = await this.getOrganization();

    if (organization) {
      this.setOrganization(organization);
    }

    return organization;
  }
}
